import { FC } from 'react';

import { ORDER_CART_TEST_ID } from '../../constants';
import { CartLegalTextData } from '../../model';
import { LegalText } from './CartLegalText.styles';

export const CartLegalText: FC<CartLegalTextData> = ({ legalText }) => {
    if (!legalText) {
        return null;
    }

    return <LegalText dataTest={ORDER_CART_TEST_ID.LEGAL_TEXT} content={legalText} />;
};
